export const TRANSACTIONS_FETCH_SUCCESS = 'TRANSACTIONS_FETCH_SUCCESS';
export const TRANSACTIONS_FETCH_ERROR = 'TRANSACTIONS_FETCH_ERROR';
export const TRANSACTIONS_IN_PROGRESS = 'TRANSACTIONS_IN_PROGRESS';
export const PAGE_NUMBER_FETCH_SUCCESS = 'PAGE_NUMBER_FETCH_SUCCESS';
export const RECEIVE_TRANSACTIONS_FETCH_SUCCESS = 'RECEIVE_TRANSACTIONS_FETCH_SUCCESS';
export const RECEIVE_TRANSACTIONS_FETCH_ERROR = 'RECEIVE_TRANSACTIONS_FETCH_ERROR';
export const RECEIVE_TRANSACTIONS_IN_PROGRESS = 'RECEIVE_TRANSACTIONS_IN_PROGRESS';
export const RECEIVE_PAGE_NUMBER_FETCH_SUCCESS = 'RECEIVE_PAGE_NUMBER_FETCH_SUCCESS';